import React, { useRef, useState } from 'react'

import { Content } from './styles'
import Modal from '../Modal'
import Button from '../../Button'

export interface ModalHandle {
  openModal: (_id: string) => void
  closeModal: () => void
}

export interface ModalProps {
  title?: string
  loading: boolean
  onSubmitButton: (_id: string) => void
}

type ModalRef = React.ElementRef<typeof Modal>

const ModalDelete: React.ForwardRefRenderFunction<ModalHandle, ModalProps> = (
  { title, onSubmitButton, loading },
  ref,
) => {
  const modalRef = useRef<ModalRef>(null)

  const [deleteId, setDeleteId] = useState<any>('')

  React.useImperativeHandle(ref, () => ({
    openModal(_id: any) {
      setDeleteId(_id)
      modalRef.current?.openModal()
    },
    closeModal() {
      modalRef.current?.closeModal()
    },
  }))

  return (
    <Modal ref={modalRef} title={title}>
      <Content>
        <Button
          fullWidth
          color='success'
          onClick={() => modalRef.current?.closeModal()}
          variantType='block'
          label='Cancelar'
        />
        <Button
          fullWidth
          color='primary'
          variantType='block'
          loading={loading}
          label='Deletar'
          onClick={() => onSubmitButton(deleteId)}
        />
      </Content>
    </Modal>
  )
}

export default React.forwardRef(ModalDelete)
